module.exports =

  displayMoment: ($el, fn) =>
    $el.css 'display', 'block'
    fn()
    $el.css 'display', 'none'



// WEBPACK FOOTER //
// ./webpack/requires/components/element-operation.coffee